import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { CustomerService } from '@core/services/customer.service';
import { AuthService } from 'src/app/core/services/authentication.service';

@Component({
  standalone: false,
  selector: 'app-callback',
  templateUrl: './callback.component.html',
  styleUrl: './callback.component.scss',
})
export class CallbackComponent implements OnInit {
  private readonly authService: AuthService = inject(AuthService);
  private readonly customerService: CustomerService = inject(CustomerService);
  private readonly router: Router = inject(Router);

  /*
    Ce composant est appelé tout de suite après la réponse du SSO.
    On l'utilise pour charger les données nécessaires à l'application
  */

  public ngOnInit(): void {
    setTimeout(() => {
      console.log('CallbackComponent initialized');
      this.customerService.getCustomer().subscribe({
        next: (customer) => {
          this.authService.isConnected.set(customer.isActive);
          if (customer.isActive) {
            // Si le client est actif, on redirige vers la page d'accueil
            this.router.navigate(['/home']);
          } else {
            // Si le client n'est pas actif, on redirige vers la page d'authentification
            this.router.navigate(['/authentication']);
          }
        },
        error: (error) => {
          console.error('Error loading customer data:', error);
          this.authService.isConnected.set(false);
          this.router.navigate(['/authentication']);
        },
      });
    }, 2000); // je ne sais pas pourquoi on a besoin de ce timeout, mais sans ça on a une boucle infinie
  }
}
